module.exports = __webpack_public_path__ + "img/zfcg.dd167dd.png";